import { Loader } from '@react-three/drei';
import React, { useState, useEffect } from 'react';
import AnimationMenuSprite from './AnimationMenuSprite';

function GifSwitcher({number, setDisplaySelector, backgroundImage}) {
  const [gif1, setGif1] = useState(null);
  const [gif2, setGif2] = useState(null);
  const [activeGif, setActiveGif] = useState(null);
  const [toggleMenu, setToggleMenu] = useState(false)
  const [background, setBackground] = useState(null)
  

  useEffect(() => {
    if(backgroundImage === "Beach"){
        setBackground("/images/backgrounds/beach.png")
    } else if (backgroundImage === "Corner Store"){
        setBackground("/images/backgrounds/city.png")
    } else if (backgroundImage === "Forest"){
        setBackground("/images/backgrounds/forest.png")
    } else if (backgroundImage === "Winter Wonderland"){
        setBackground("/images/backgrounds/winter-forest.png")
    } else if (backgroundImage === "Outer Space"){
        setBackground("/images/backgrounds/space.png")
    } else if (backgroundImage === "Red"){
        setBackground("/images/backgrounds/red.png")
    } else if (backgroundImage === "Blue"){
        setBackground("/images/backgrounds/blue.png")
    } else {
        setBackground("/images/backgrounds/yellow.png")
    }
  }, [backgroundImage]);
  
  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu)
  }

  const fetchIdleGif = async (number) => {
    try {
        const response = await fetch(`https://dc.yolokidz.io/api/animations/${number}_idle_right`);
        if (!response.ok) {
            // Handle error if file not found or another server error
            console.error('An error occurred:', response.status, response.statusText);
            return;
        }
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        return url
    } catch (error) {
        // Handle any other errors
        console.error('Failed to fetch animation:', error);
    }
  };

  const fetchWalkGif = async (number) => {
    try {
        const response = await fetch(`https://dc.yolokidz.io/api/animations/${number}_walk_right`);
        
        if (!response.ok) {
            // Handle error if file not found or another server error
            console.error('An error occurred:', response.status, response.statusText);
            return;
        }
        
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        return url
    } catch (error) {
        // Handle any other errors
        console.error('Failed to fetch animation:', error);
    }
  };

  useEffect(() => {
    Promise.all([fetchIdleGif(number), fetchWalkGif(number)]).then(([gif1Data, gif2Data]) => {
      setGif1(gif1Data);
      setGif2(gif2Data);
      setActiveGif(gif1Data); // Default to the first gif
    });
  }, [number, backgroundImage]);

  const handleSwitchChange = (e) => {
    setActiveGif(e === 0 ? gif1 : gif2);
  };

  

  return (<>
  {toggleMenu && <AnimationMenuSprite handleSwitchChange={handleSwitchChange} setDisplaySelector={setDisplaySelector}/>}
  <div className='toggleDiv' onClick={handleToggleMenu}></div>
    <div className='viewer-animation pixelated'>
        {activeGif ? (
          <div style={{ position: "relative" }}>
          <img
            src={background}
            alt="background"
            style={{
              position: "absolute",
              zIndex: 1,
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              animation: activeGif === gif2 ? 'scroll 2s linear infinite' : 'none',
            }}
          />
          <img
            style={{
              position: "relative",
              zIndex: 2,
              height: "100%",
              width: "100%",
            }}
            src={activeGif}
            alt="GIF"
          />
        </div>
          
        ) : (
          <Loader />
        )}
    </div>
  </>);
}

export default GifSwitcher;
